module.exports = __webpack_public_path__ + "static/media/image008.65651564.jpg";